import { useEffect, useRef, useState } from 'react';

const useCountdown = (
    initialSeconds: number,
    onComplete: () => void,
    restartKey: number = 0,
) => {
    const [seconds, setSeconds] = useState(initialSeconds);
    const onCompleteRef = useRef(onComplete);
    onCompleteRef.current = onComplete;

    useEffect(() => {
        setSeconds(initialSeconds);
        const id = setInterval(() => {
            setSeconds((s) => {
                const next = s - 1;
                if (next <= 0) {
                    clearInterval(id);
                    return 0;
                }
                return next;
            });
        }, 1000);
        return () => clearInterval(id);
    }, [initialSeconds, restartKey]);

    useEffect(() => {
        if (seconds === 0) {
            onCompleteRef.current();
        }
    }, [seconds]);

    return seconds;
};

export default useCountdown;
